// extracted by mini-css-extract-plugin
export default {"googlePayContainer":"GooglePayButton-module__googlePayContainer--ww7QA","googlePayRoundBorder":"GooglePayButton-module__googlePayRoundBorder--gOaZC"};